<template>
  <div class="radio-group">
    <el-radio-group v-model="radio1" @change="radioChange">
      <el-radio-button v-for="(n, i) in options" :key="'radio' + i" :label="n.value">
        <slot name="start"></slot>
        {{ n.label }}
        <slot name="end" :params="n"></slot>
      </el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "RadioGroup",
  props: {
    options: Array,
    inputValue: Number,
  },
  data() {
    return {
      radio1: this.inputValue || (this.options && this.options[0] && this.options[0].value),
    };
  },
  watch: {
    options: {
      deep: true,
      handler(o) {
        if (o && o[0] && o[0].value) {
          this.radio1 = o[0].value;
        }
      },
    },
  },
  methods: {
    radioChange(v) {
      // console.log(v);
      this.$emit("radioChange", v);
    },
  },
};
</script>

<style lang="less" scoped>
.radio-group {
  text-align: center;
  margin-bottom: 20px;
}
</style>
